import { Component, h } from '@stencil/core';

@Component({
  tag: 'ugc-review-list-keleton',
  shadow: false,
})
export class UgcReviewListSkeleton {
  render() {
    return (
      <div class="bg-white mt-16">
        {[0, 1, 2].map(item => (
          <ugc-review-list-item-keleton key={item} />
        ))}
        <div class="w-full ">
          <ugc-skeleton width="100%" height="48" />
        </div>
      </div>
    );
  }
}
